import React from 'react'
import { MsalProvider } from '@azure/msal-react'
import { msalInstance } from '../../config/msalConfig'

export default props => <MsalProvider instance={msalInstance}>{props.children}</MsalProvider>
